const FORMAT = /^[0-9]{4}(-[0-9])?$/

module.exports = function() {
  return value => {
    if (!value || !FORMAT.test(value)) return false
    return true
  }
}
